import React, { useEffect, useState } from 'react';
import Grid from "@material-ui/core/Grid";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from "@material-ui/icons/Close";
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";

const ChangePassword = (props) => {
    const [CurrentPassword,setCurrentPassword] = useState('');
    const [NewPassword,setNewPassword] = useState('');
    const [ConfirmPassword,setConfirmPassword] = useState('');
    const [response, fetchData] = UseFetchData();

    const validationSchema = Yup.object({
        CurrentPassword: Yup.string().required('Required!'),
        NewPassword: Yup.string().required('Required!'),
        ConfirmPassword: Yup.string().oneOf([Yup.ref('NewPassword'), null], "Passwords don't match").required('Required!'),
    });

    const onSubmit = values => {
        //console.log(values);
        var bodyFormData = new FormData();
        bodyFormData.append("UserID", props.UserID);
        bodyFormData.append("CurrentPassword", values.CurrentPassword);
        bodyFormData.append("Password", values.ConfirmPassword);
        fetchData("User/UpdatePassword", bodyFormData);
    };

    useEffect(() => {
        if(response.Response === true){
            alert('Updated Successfully.');
            props.setOpen(false);
        }
        else if(response.Response === false){
            console.log(response.Message);
            alert('Failed.');
        }
    },[response])

    return(
        <div>
            <Formik initialValues={{ CurrentPassword: CurrentPassword, NewPassword: NewPassword, ConfirmPassword:ConfirmPassword }}
                validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <Grid spacing={1} container>
                            <Grid item xs={12} >
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='Current Password'
                                    name='CurrentPassword'
                                    onChange={(e) => { setCurrentPassword(e.target.value) }}
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='New Password'
                                    name='NewPassword'
                                    onChange={(e) => { setNewPassword(e.target.value) }}
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='Confirm Password'
                                    name='ConfirmPassword'
                                    onChange={(e) => { setConfirmPassword(e.target.value) }}
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <div style={{width:'100%'}}>
                                    <div style={{display:'flex',justifyContent:'center',alignContent:"center"}}>
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            startIcon={<SaveIcon />}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => {props.setOpen(false);}}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </div>
    );
}

export default ChangePassword;
